import apiClient, { safeJson } from '@/api/client';
import {
    GetCenterSessionCommissionTableParams,
    GetCenterSessionCommissionTablesResponse,
    GetCoachSessionCommissionTableParams,
    GetCoachSessionCommissionTableResponse,
    PutCenterSessionCommissionTablesBody,
} from './types';

/**
 * @method get
 * @brief 센터 전체 강사 세션 구간 조회
 */
export const getCenterSessionCommissionTables = async ({
    centerId,
    year,
    month,
}: GetCenterSessionCommissionTableParams) => {
    const res = await apiClient.get(`v1/coachSessionCommissionTables/center/${centerId}`, {
        searchParams: { year, month },
    });

    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as GetCenterSessionCommissionTablesResponse | null,
    };
};

/**
 * @method get
 * @brief 특정 강사 세션 구간 조회 (해당 월 미설정 시 전월 자동 복제)
 */
export const getCoachSessionCommissionTable = async ({
    centerId,
    coachId,
    year,
    month,
}: GetCoachSessionCommissionTableParams) => {
    const res = await apiClient.get(`v1/coachSessionCommissionTables/center/${centerId}/coach/${coachId}`, {
        searchParams: { year, month },
    });

    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as GetCoachSessionCommissionTableResponse | null,
    };
};

/**
 * @method patch
 * @brief 센터 전체 강사 세션 구간 일괄 저장
 */
export const putCenterSessionCommissionTables = async ({
    centerId,
    body,
}: {
    centerId: string;
    body: PutCenterSessionCommissionTablesBody;
}) => {
    const res = await apiClient.patch(`v1/coachSessionCommissionTables/center/${centerId}`, {
        json: body,
    });

    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as { success: boolean } | null,
    };
};
